import {UnreachableError} from '../../../../libs/shared/core/src/helpers/types/customErrors';
import {ContactCardLocationsEnum} from '../../../store/panels/contacts/contactCard/contactCardPanelState';

export function computeContactCardLocationTracking(location: ContactCardLocationsEnum) {
  switch (location) {
    case ContactCardLocationsEnum.MESSAGE_VIEWER:
      return 'p3';

    case ContactCardLocationsEnum.CALENDAR:
    case ContactCardLocationsEnum.CALENDAR_NEW_EVENT:
      return 'calendar';

    case ContactCardLocationsEnum.SYNOPSIS:
      return 'synopsis';

    default:
      throw new UnreachableError(location);
  }
}
